import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Container,
  Avatar,
  TextField,
  Button, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from "react-router-dom";

function PhotosFollowingPage() {
  const history = useHistory();
  const [photos, setPhotos] = useState([]);
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState('');
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  /*const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };*/
  const [photoFileName, setPhotoFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPhotoFileName(file?.name || "");
  };

  const handlePost = async () => {
        if (!image) return alert("Select a photo first");

        const formData = new FormData();
        formData.append("image", image);
        formData.append("description", description);

        try {
            await axios.post('/photos/postPhotos', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true  
            });
            setOpen(false);
            setImage(null);
            setDescription('');
            //alert("Photo posted!");
        } catch (err) {
            console.error(err);
            alert("Upload failed");
        }
    };

  /*useEffect(() => {
    axios.get('/photos/followingPhotos')
      .then(res => setPhotos(res.data))
      .catch(err => console.error(err));
  }, []);*/
  const fetchPhotos = async (overrideCursor = cursor) => {
    if (loading || !hasMore) return;

    try {
      setLoading(true);

      const res = await axios.get('/photos/followingPhotos', {
        params: {
          cursor: overrideCursor,
          limit: 10
        }
      });

      const newPhotos = Array.isArray(res.data.posts) ? res.data.posts : [];

      setPhotos(prev => {
        const ids = new Set(prev.map(p => p._id));
        const filtered = newPhotos.filter(p => !ids.has(p._id));
        return [...prev, ...filtered];
      });

      setCursor(res.data.nextCursor);
      setHasMore(res.data.hasMore);

    } catch (err) {
      console.error("Error loading photos", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPhotos([]);
    setCursor(null);
    setHasMore(true);
  }, []);

  useEffect(() => {
    if (cursor === null && hasMore) {
      fetchPhotos(null);
    }
  }, [cursor, hasMore]);

  const observer = useRef();

  const lastPhotoRef = useCallback(node => {
    if (loading) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        fetchPhotos();
      }
    });

    if (node) observer.current.observe(node);

  }, [loading, hasMore]);

  const toggleVote = async (postId) => {
        console.log("Trying to upvote:", postId);
        try {
            const res = await axios.post(`/photos/${postId}/upvote`);
            setPhotos(prev =>
                prev.map(p =>
                    p._id === postId
                    ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
                    : p
                )
            );
        } catch (err) {
            console.error("Vote error", err);
        }
    };

  const handleAddComment = async (postId, commentText) => {
        if (!commentText.trim()) return;

        try {
            const res = await axios.post(`/photos/${postId}/comment`, { text: commentText });
            setPhotos(prev =>
            prev.map(p =>
                p._id === postId
                ? { ...p, comments: res.data, newComment: "" }
                : p
            )
            );
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };

  const joinVideoCall = async (postId) => {
        try {
            const res = await axios.post(`/photo/${postId}/video-room`);
            const roomUrl = res.data.url;
            window.open(roomUrl, "_blank");
        } catch (err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular", path: "/mainsocial/photos/popular" },
      { label: "Following", path: "/mainsocial/photos/following" },
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >*/}
            {/*<Button variant="contained" onClick={() => history.push('/photos/popularPhotos')}>
            Popular
            </Button>*/}
            {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/popularPhotos')}
                    >
                        Popular
                    </Button>
            <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/followingPhotos')}
                    >
                        Following
                    </Button>*/}
              {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}

                  <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Photo
                    </Button>
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
            {/*<Button variant="contained" onClick={() => history.push('/photos/recommendedPhotos')}>
            Recommended
            </Button>*/}
            <>
                {/*<Button onClick={() => setOpen(true)} variant="contained">Post Photo</Button>*/}
                {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Photo
                    </Button>*/}
                {/*<Dialog open={open} onClose={() => setOpen(false)}>*/}
                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                      sx: {
                      backgroundColor: "#FFFDF8",
                      borderRadius: 3,
                      },
                  }}
                  >
                    <DialogTitle sx={{ fontWeight: "bold" }}>Post a Photo</DialogTitle>
                    {/*<DialogContent>*/}
                    <DialogContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          pt: 1,
                        }}
                    >
                      {/* Upload Photo Button */}
                      <Button variant="outlined" component="label">
                        Upload Photo
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleFileChange}
                        />
                      </Button>

                      {/* Selected filename */}
                      {photoFileName && (
                        <Typography variant="caption" color="text.secondary">
                          Selected photo: {photoFileName}
                        </Typography>
                      )}
                    {/*<input type="file" accept="image/*" onChange={handleFileChange} />*/}
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Write a description"
                        margin="normal"
                    />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handlePost} variant="contained">Post</Button>
                    </DialogActions>
                </Dialog>
            </>
            {/*</Box>*/}
    {/*<Container maxWidth="md" sx={{ mt: 4 }}>*/}
      {photos.map((photo, idx) => {
        const isLast = idx === photos.length - 1;

        return (
        <Box
          key={photo._id}
          ref={isLast ? lastPhotoRef : null}
          //onClick={() => history.push(`/photos/${photo._id}/comments`)}
          //onClick={() => history.push(`/post/${photo._id}/comments`)}
          onClick={() => history.push(`/photos/${photo._id}/comments`, { source: "following" })}
          p={2}
          my={2}
          border="1px solid #ccc" 
          borderRadius="8px"
          sx={{ 
            position: 'relative', 
            maxWidth: 900, 
            mx: "auto",
            my: 2, 
            cursor: "pointer",
              "&:hover": {
               backgroundColor: "#f9f9f9"
            }
            }}
        >
        {/*<Box
                        key={post._id} // unique key for each list item
                        p={2} // padding inside box
                        my={2} // vertical margin between posts
                        border="1px solid #ccc" // light grey border
                        borderRadius="8px" // rounded corners
                        sx={{ 
                            position: "relative", 
                            maxWidth: 900, // limit width 
                            mx: "auto", // center horizontally
                            my: 2, // vertical spacing between each post
                        }}
                    >*/}
        {/*<Box key={photo._id} sx={{ position: 'relative', mb: 4 }}>*/}
          {/*<Card sx={{ boxShadow: 3 }}>*/}
            {/*<Box position="absolute" top={8} right={8} zIndex={1}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => joinVideoCall(photo._id)}
              >
                Join Video Call
              </Button>
            </Box>*/}

            {/*
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
              <Avatar sx={{ mr: 2 }}>
                {photo.author?.username?.[0] || "?"}
              </Avatar>
              <Typography variant="subtitle1">
                {photo.author?.username || "Unknown"}
              </Typography>
            </Box>

            <CardMedia
              component="img"
              image={`http://localhost:3000${photo.imageUrl}`}  
              alt="User photo"
              sx={{ maxHeight: 500, objectFit: 'cover' }}
            />

            <CardContent>
              <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                {photo.description}
              </Typography>
            </CardContent>
            */}
            <Box display="flex" alignItems="flex-start" gap={1}>
              <Avatar
                src={photo.author?.profileImageUrl || '/default-avatar.jpg'}
                alt={`${photo.author?.first_name || ''} ${photo.author?.last_name || ''}`}
                onClick={(e) => visitProfile(e, photo.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
              />
              <Box>
               <Typography variant="subtitle1" fontWeight="bold"
               onClick={(e) => visitProfile(e, photo.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                {photo.author?.first_name && photo.author?.last_name
                  ? `${photo.author.first_name} ${photo.author.last_name}`
                  : 'Unknown Name'}
               </Typography>
               <Typography variant="body2" color="text.secondary"
               onClick={(e) => visitProfile(e, photo.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                @{photo.author?.username || 'unknown'}
               </Typography>

               {/*<CardMedia
                component="img"
                image={`http://localhost:3000${photo.imageUrl}`}  
                alt="User photo"
                //sx={{ maxHeight: 500, objectFit: 'cover' }}
              />*/}

              {/*}
              <CardContent>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                  {photo.description}
                </Typography>
              </CardContent>
              */}
              {/*<Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                {photo.description}
               </Typography>*/}

                {/*
               <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                {post.content}
               </Typography>
               */}

               {/* Date */}
               {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                {new Date(photo.createdAt).toLocaleString()}
               </Typography>*/}

               </Box>
            </Box>

            <CardMedia
              component="img"
              image={photo.imageUrl}
              alt="User photo"
              sx={{
                maxWidth: 900,       // large but still constrained
                width: '100%',
                display: 'block',
                margin: '16px auto 0 auto', // centers horizontally, adds top space
                borderRadius: 2,
                objectFit: 'contain'
              }}
            />

            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
              {photo.description}
            </Typography>

            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                {`${new Date(photo.created_at).toLocaleString()}, ${photo.commentCount} ${
                                    photo.commentCount === 1 ? 'reply' : 'replies'
                                }`}
                            </Typography>

            {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                            <Button
                                size="small"
                                variant={photo.voted ? "contained" : "outlined"}
                                onClick={(e) => {
                                  e.stopPropagation();  
                                  toggleVote(photo._id)
                                }}
                            >
                                ▲ {photo.voted ? "Unvote" : "Upvote"}
                            </Button>
                            <Typography variant="body2">{photo.upvotes} upvotes</Typography>
                        </Box>*/}
              <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {photo.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(photo._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(photo._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{photo.upvotes} Power Votes</Typography>
                   </Box>

            {/*}
            <Box mt={1} px={2}>
              <Button
                size="small"
                variant={photo.voted ? "contained" : "outlined"}
                onClick={() => toggleVote(photo._id)}
              >
                {photo.voted ? "Unvote" : "Upvote"}
              </Button>
              <Typography variant="body2" component="span" ml={2}>
                {photo.upvotes || 0} upvotes
              </Typography>
            </Box>

            <Box mt={2} px={2}>
              <TextField
                placeholder="Add a comment"
                value={photo.newComment || ""}
                onChange={(e) =>
                  setPhotos(prev =>
                    prev.map(p =>
                      p._id === photo._id ? { ...p, newComment: e.target.value } : p
                    )
                  )
                }
                fullWidth
                size="small"
              />
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleAddComment(photo._id, photo.newComment)}
                sx={{ mt: 1 }}
              >
                Submit Comment
              </Button>
            </Box>
            */}
            {/*
            <Box px={2} pb={2}>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                onClick={() => history.push(`/photos/${photo._id}/comments`)}
              >
                View Comments
              </Button>
            </Box>
            */}
            {/*<Button
                            variant="outlined"
                            size="small"
                            onClick={() => history.push(`/photos/${photo._id}/comments`)}
                            sx={{ mt: 1 }}
                        >
                            View Comments
                        </Button>*/}
          {/*</Card>*/}
        </Box>
        );
                })}
      {photos.length === 0 && (
        <Typography variant="h6" align="center" color="text.secondary">
          No photo posts yet from users you follow.
        </Typography>
      )}
    {/*</Container>*/}
    </div>
    );
/*
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      {photos.map((photo) => (
        <Card key={photo._id} sx={{ mb: 4, boxShadow: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
            <Box position="absolute" top={8} right={8}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => joinVideoCall(post._id)}
              >
                Join Video Call
              </Button>
            </Box>
            <Avatar sx={{ mr: 2 }}>
              {photo.author?.username?.[0] || "?"}
            </Avatar>
            <Typography variant="subtitle1">
              {photo.author?.username || "Unknown"}
            </Typography>
          </Box>
          <CardMedia
            component="img"
            image={`http://localhost:3000${photo.imageUrl}`}  
            alt="User photo"
            sx={{ maxHeight: 500, objectFit: 'cover' }}
          />
          <CardContent>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {photo.description}
            </Typography>
          </CardContent>
          <Box mt={1}>
            <Button
              size="small"
              variant={photo.voted ? "contained" : "outlined"}
              onClick={() => toggleVote(photo._id)}
            >
              {photo.voted ? "Unvote" : "Upvote"}
            </Button>
            <Typography variant="body2" component="span" ml={2}>
              {photo.upvotes || 0} upvotes
            </Typography>
          </Box>
          <Box mt={2}>
            <TextField
              placeholder="Add a comment"
              value={photo.newComment || ""}
              onChange={(e) =>
                setPhotos(prev =>
                  prev.map(p =>
                    p._id === post._id ? { ...p, newComment: e.target.value } : p
                  )
                )
              }
                fullWidth
                size="small"
            />
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleAddComment(photo._id, photo.newComment)}
                sx={{ mt: 1 }}
            >
              Submit Comment
            </Button>
          </Box>

          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            onClick={() => history.push(`/photos/${photo._id}/comments`)}
          >
            View Comments
          </Button>
        </Card>
      ))}
      {photos.length === 0 && (
        <Typography variant="h6" align="center" color="text.secondary">
          No photo posts yet from users you follow.
        </Typography>
      )}
    </Container>
  );
  */
}

export default PhotosFollowingPage;
